import Avatar from '@mui/material/Avatar'
import { object } from 'prop-types'
import { colors } from '@global/constants'

export const CvsAccountLogo = ({ account, style = {} }) => {
  return account.logo_slug ? (
    <Avatar
      alt={`${account.name}-avatar`}
      src={`/api/v1/logo/${account.logo_slug}`}
      style={{ margin: '5px', backgroundColor: colors.blue.smokey, ...style }}
      variant="rounded"
    />
  ) : (
    <Avatar
      style={{ margin: '5px', backgroundColor: colors.blue.smokey, ...style }}
      variant="rounded"
    >
      {account.name
        ? account.name
            .split(' ')
            .map(part => {
              return part[0]
            })
            .join('')
        : ''}
    </Avatar>
  )
}

CvsAccountLogo.propTypes = {
  account: object.isRequired,
  style: object,
}
